<template>
    <v-text-field
      v-model="user_name"
      class="text-xs-center"
      :label="label"
      outlined
      append-icon="search"
      @click="check_default()"
      @click:append="validate_code()"
      @keyup.enter="validate_code()"
      @change="validate_code()"
      @input="clear()"
      :disabled="loadSearch"
      :loading="loadSearch"
      dense hide-details
    >
    </v-text-field>
  </template>
  <script>
  export default {
    name: "FindUser",
    props: {
    default_input: {
        type: String,
      },
    },
    mounted(){
        if(this.default_input!=null){
            this.user_name=this.default_input;
        }
    },
    data: () => ({
      user_name: null,
      user_fullname:null,
      loadSearch: false,
    }),  
    computed:{
        label(){
            let description='Usuario designado';
            if(this.user_fullname!=null){
                return description+=`: ${this.user_fullname}`;
            }
            return description;
        }
    },
    methods: {
        check_default(){
            if(this.user_name!=null && this.user_name==this.default_input){
                return this.user_name=null;
            }
        },
      async validate_code() {
        if (this.user_name == "" || this.user_name == null) {
            this.$toast.warning("Indique un nombre de usuario!");
            return;
        }
        try {
          this.loadSearch = true;
         // this.$emit("loading", true);
          const result = await this.api_Get("inventory/find_user/"+this.clearInputFilter(this.user_name, 0));
          const data = await result.json();
          if (result.status == 200) {
            if ((await data.length) == 0) {
                this.$toast.info("USUARIO NO ENCONTRADO!");
              this.loadSearch = false;
              return;
            }
            this.user_name=data[0].use_username;
            this.user_fullname=data[0].use_fullname;
            this.$emit("set-user", data);
          } else {
            this.$toast.error(data.error);
          }
        } catch (error) {
            this.$toast.error(error);
        }
        this.loadSearch = false;
      },
      clear() {
          this.$emit("clear", true);
      },
    },
  };
  </script>
  
  
  